import LabelSelect from './LabelSelect.vue'
LabelSelect.install = function (Vue) {
  Vue.component(LabelSelect.name, LabelSelect);
}

export default [LabelSelect]



// WEBPACK FOOTER //
// ./src/components/label/index.js